import { atom } from 'recoil';
import { IConfigSegmento } from '../../../commons/types/config';

export const configSegmentoAtom = atom<IConfigSegmento[]>({
  key: 'segmento',
  default: [] as IConfigSegmento[],
});
